module.exports = __webpack_public_path__ + "img/treatments.e3ce66c5.svg";